export const deviceSize = {
    mobile: 640,
    tablet: 768,
    laptop: 1024,
    desktop: 1280,
    widescreen: 1536,
  };